import { Results } from 'app/components/Results';

const ResultsPage = () => {
  return <Results />;
};

export default ResultsPage;
